module.exports = __webpack_public_path__ + "img/noavatar.391d1660.png";